import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatMenuModule } from '@angular/material/menu';
import { CoreModule } from 'src/app/core/core.module';
import { GeneralModule } from '../../general/general.module';
import { MercheMarketplaceModule } from '../../merche-marketplace/merche-marketplace.module';
import { CommunityV2Component } from './community-v2.component';
import { CmSidenavComponent } from './cm-sidenav/cm-sidenav.component';
import { CmSpaceRowComponent } from './cm-space-row/cm-space-row.component';
import { CmChatComponent } from './cm-chat/cm-chat.component';
import { CmChatHeaderComponent } from './cm-chat-header/cm-chat-header.component';
import { CmMessageComponent } from './cm-message/cm-message.component';
import { CmPollComponent } from './cm-poll/cm-poll.component';
import { CmTipCardComponent } from './cm-tip-card/cm-tip-card.component';
import { CmComposerComponent } from './cm-composer/cm-composer.component';
import { CmSidePanelComponent } from './cm-side-panel/cm-side-panel.component';

/** New community page (v2). Routed from IndigenousCloudRoutingModule behind communityVersionGuard. */
@NgModule({
  declarations: [
    CommunityV2Component,
    CmSidenavComponent,
    CmSpaceRowComponent,
    CmChatComponent,
    CmChatHeaderComponent,
    CmMessageComponent,
    CmPollComponent,
    CmTipCardComponent,
    CmComposerComponent,
    CmSidePanelComponent,
  ],
  imports: [CommonModule, RouterModule, MatMenuModule, CoreModule, GeneralModule, MercheMarketplaceModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [CommunityV2Component, CmChatComponent],
})
export class CommunityV2Module {}
